const TreeViewKey = Symbol("TreeView");
export {
  TreeViewKey as T
};
//# sourceMappingURL=types-095ae969.mjs.map
